import {
  ApplicationTabRatePlanFormDto,
  type ApplicationTabRatePlanFormInterface,
} from '@zaoblako/shared/modules/security/dtos/application/tab/application-tab-rate-plan-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { mapSchema } from '@zaoblako/shared/modules/serde/schemas/map.schema';

import * as yup from 'yup';

/** Application section request body for rate plan create/update APIs - DTO signature */
export interface ApplicationSectionRatePlanFormInterface {
  /** Section's tabs */
  tabs: Record<string, ApplicationTabRatePlanFormInterface>;
}

/** Application section request body for rate plan create/update APIs - DTO schema */
export const ApplicationSectionRatePlanFormDto = SerdeDtoClass.create<ApplicationSectionRatePlanFormInterface>(
  SecurityDtoKeysEnum.APPLICATION_SECTION_RATE_PLAN_FORM_DTO,
  {
    tabs: {
      label: 'Вкладки',
      nested: ApplicationTabRatePlanFormDto,
      serializer: (_, nested) => mapSchema(
        yup.string(),
        nested,
      ),
    },
  },
);
